<template>
  <div class="crumbs">
    <div class="crumbs_path">
      <div class="titel sel" @click="$router.push('/NewHome')">{{ $t("register.home_page") }}</div>
      <div v-if="pathName">
        <img src="../../../../assets/newImage/jiantou2_you_hui.png" style="width: 12px;height: 12px;">
      </div>
      <div class="titel">{{ pathName }}</div>
    </div>
    <!-- 占位 -->
    <div class="placeholder_element"></div>
    <div class="setting_box">
      <!-- <span class="lang" :class="langStyle ? '' : 'check'" @click="$common.changeLanguage('zh')">中</span>
        <span class="separate"></span>
        <span class="lang" :class="langStyle ? 'check' : ''" @click="$common.changeLanguage('en')">En</span> -->
      <span style="margin-left: 30px;color: #1e50f0;font-weight: bold;" @click="$router.push('/Login')"
        v-if="showToLogin">{{ $t('register.existing_account') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  methods: {

  },
  props: {
    showToLogin: {
      showToLogin: Boolean,
      default: true
    },
    pathName: {
      pathName: String,
      default: ''
    }
  },
  computed: {
    langStyle () {
      return localStorage.getItem('lang') == 'en'
    }
  }
}
</script>

<style lang="less" scoped>
.crumbs {
  width: 100%;
  display: grid;
  grid-template-columns: auto 1fr auto;

  .crumbs_path {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-column-gap: 15px;
    align-items: center;
    font-size: 14px;
    font-family: '微软雅黑';
    cursor: pointer;
  }

  .setting_box {
    font-size: 14px;
    cursor: pointer;
    color: #848484;

    .lang.check {
      color: #000;
    }
  }
}

.titel.sel {
  color: #1e50f0;
}

.titel:hover {
  text-decoration: underline;
}

.separate::before {
  content: '';
  display: inline-block;
  width: 1px;
  height: 10px;
  border-left: #e9e9e9 1px dashed;
  margin: 0 12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/newPages/login/components/Crumbs.vue